import React from "react";
import { Icon } from "@iconify/react";

import classes from "./PageName.module.css";

const PageName = ({ pageName, totalRecords, excelExport }) => {
  return (
    <div className={classes["page-name-wrapper"]}>
      <div>
        <p className={classes["page-name"]}>{pageName}</p>
        {totalRecords ? (
          <p className={classes["total-records"]}>
            We have {totalRecords?.length} {pageName.toLowerCase()}
          </p>
        ) : null}
      </div>
      {excelExport ? (
        <button className="excel-button" onClick={excelExport}>
          Dowland as Excel
          <Icon width="20" color="white" icon="file-icons:microsoft-excel" />
        </button>
      ) : null}
    </div>
  );
};

export default PageName;
